//import {initLightslider} from "./custom/lightslider";
//import {initCssEvents} from "./custom/cssEvents";

$(function () {


	$(".fancybox").fancybox();

	$("body").on("click", '.varianty li input', function () {
		li = $(this).parents("li");
		if ($(this).is(":selected")) {
			li.addClass('selected');
		} else {
			li.removeClass('selected');
		}
	});

	$('.showMoreInfo').click(function () {
		$('.descriptionCategory').css('height', 'auto');
		$(this).hide();
		$(".showLessInfo").css('display', 'block');
	});

	$('.showLessInfo').click(function () {
		$('.descriptionCategory').css('height', '58px');
		$(this).hide();
		$(".showMoreInfo").show();
	});

	// menu pro mobil
	$('#left .menuMobile').click(function () {
		$("#left .menu").toggle();
	});

	// zobrazení Hlídacího psa
	$('.toggleWatchDog').click(function () {
		$(".watchDog").toggle();
		$('.toggleWatchDog').hide();
	});

	$('.watchDog .closeButton').click(function () {
		$(".watchDog").toggle();
		$('.toggleWatchDog').show();
	});


});

// konfigurace výstupu autocomplete
function anyShopAutocompleteRenderItem(name, typeId, typeName, image) {
	if (typeName == 'položka') {
		return "<a><span class='acimg'><img src='" + absoluteUrl + "/soubory/product/male/" + image + "' /></span>" + name + "</a>";
	} else if (typeName == 'kategorie') {
		return "<a>" + name + " <small class='" + typeId + "' >(" + typeName + ")</small></a>";
	} else {
		return "<a>" + name + " <small class='" + typeId + "' >(" + typeName + ")</small></a>";
	}
}
